const MapButtonsToContextMenu = (buttons, buttonClickHandler) => {

    const mappedButtons = buttons.map((button) => {
        return { key: button.Key,
                 text: button.Text,
                 iconProps: { iconName: button.Icon },
                 onClick: () => buttonClickHandler(button),
                 primaryAction: button.PrimaryAction,
                 button: button,
                 entryStates: button.EntryStates,
                 workflow: button.Workflow
                }
    })

    return mappedButtons;
}

export default MapButtonsToContextMenu;